import React from "react"
import { RouterProvider, createHashRouter } from "react-router-dom"

import RouteErrorFallback from "src/components/ErrorBoundaryProvider/RouteErrorFallback"

import PaymentsView from "./PaymentsView"

const PaymentsContainer = () => {
  const router = createHashRouter([
    {
      path: "/",
      errorElement: <RouteErrorFallback />,
      element: <PaymentsView />,
    },
  ])

  return <RouterProvider router={router} />
}

export default PaymentsContainer
